'use client';

import type {FC, PropsWithChildren} from 'react';
import clsx from 'clsx';
import {usePathname} from 'next/navigation';

import {buttonClasses} from '@/components/button';

interface Props {
	text?: string;
	href: string;
}

export const Link365: FC<PropsWithChildren<Props>> = ({text, href}) => {
	const pathname = usePathname();
	return (
		<div
			className={clsx(
				buttonClasses,
				'text-turquoise-700',
				pathname === href ? 'rounded-lg' : 'rounded-[3.5rem]',
				'hover:rounded-lg',
				'!text-base',
				'!font-medium',
				'!h-12',
				'!px-10',
				'mr-20',
			)}
		>
			{text}
		</div>
	);
};
